module.exports = __webpack_public_path__ + "static/media/13.57149c94.jpg";